var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoUsuario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C6.48333 22 2 17.5167 2 12C2 6.48333 6.48333 2 12 2C17.5167 2 22 6.48333 22 12C22 17.5167 17.5167 22 12 22ZM12 2.83333C6.94167 2.83333 2.83333 6.94167 2.83333 12C2.83333 17.0583 6.94167 21.1667 12 21.1667C17.0583 21.1667 21.1667 17.0583 21.1667 12C21.1667 6.94167 17.0583 2.83333 12 2.83333ZM12 13.2499C9.81663 13.2499 8.04163 11.4749 8.04163 9.29158C8.04163 7.10825 9.81663 5.33325 12 5.33325C14.1833 5.33325 15.9583 7.10825 15.9583 9.29158C15.9583 11.4749 14.1833 13.2499 12 13.2499ZM12 6.16659C10.275 6.16659 8.87496 7.56659 8.87496 9.29158C8.87496 11.0166 10.275 12.4166 12 12.4166C13.725 12.4166 15.125 11.0166 15.125 9.29158C15.125 7.56659 13.725 6.16659 12 6.16659ZM16.8916 17.5915C16.9582 17.7415 17.1082 17.8332 17.2666 17.8332C17.3249 17.8332 17.3916 17.8248 17.4332 17.7915C17.6416 17.6915 17.7332 17.4415 17.6332 17.2331C16.6082 15.0581 14.3916 13.6582 11.9916 13.6582C9.59157 13.6582 7.3749 15.0665 6.3499 17.2331C6.2499 17.4415 6.34157 17.6915 6.5499 17.7915C6.76657 17.8915 7.00823 17.7998 7.10824 17.5915C7.9999 15.7165 9.91657 14.4999 11.9999 14.4999C14.0832 14.4999 15.9999 15.7082 16.8916 17.5915Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoUsuario);
export default __webpack_public_path__ + "static/media/icono_usuario.d051fa23d6da490adb1b0a6a60564452.svg";
export { ForwardRef as ReactComponent };